/**
 * The last stretch before a budget limit, where a warning is informative rather than alarmist.
 *
 * Shared by every surface that renders this threshold — `BudgetMeter`, `SpendSummaryPanel`, the
 * attention-list synthesis, and the self-service usage banner — so "when does amber start" cannot
 * drift between them the way it already had (each of the first three defined its own `0.85`).
 */
export const NEAR_LIMIT_UTILISATION = 0.85;

export type UsageLimitSeverity = 'ok' | 'warning' | 'reached';

/**
 * `budgetUsd <= 0` means uncapped — never a warning, same as `BudgetMeter`'s "No limit" case.
 * `overBudget` beats a recomputed ratio when it disagrees, since the backend is the one that
 * actually enforces the limit.
 */
export function usageLimitSeverity(usage: {
  spendUsd: number;
  budgetUsd: number;
  overBudget: boolean;
}): UsageLimitSeverity {
  if (!usage.budgetUsd || usage.budgetUsd <= 0) return 'ok';
  if (usage.overBudget) return 'reached';
  return usage.spendUsd / usage.budgetUsd >= NEAR_LIMIT_UTILISATION ? 'warning' : 'ok';
}
